import { Component, OnInit, Input } from '@angular/core';
import { ZoningCodeService } from 'src/app/core/services/zoning-code.service';
import { HttpResponse } from '@angular/common/http';
import { DownloadService } from 'src/app/core/services/download.service';
import { ImportTemplateType } from 'src/shared/enums/import-template-type.enum';

@Component({
    standalone: false,
    selector: 'app-download-zoning-code-import-template',
    templateUrl: './download-zoning-code-import-template.component.html',
    styleUrls: ['./download-zoning-code-import-template.component.scss']

})
export class DownloadZoningCodeImportTemplateComponent implements OnInit {
    @Input() templateType: ImportTemplateType;

    constructor(private zoningCodeService: ZoningCodeService) {}

    ngOnInit(): void {}

    downloadTemplate(): void {
        const zoningCodeName = ZoningCodeService.getZoningCodeFileNamePrefix(this.zoningCodeService.zoningCodeName);

        let serviceMethod = this.zoningCodeService.getZoningCodeImportTemplate();
        let defaultFileName = 'zoning-code-import-template.csv';

        switch (this.templateType) {
            case ImportTemplateType.ZONE_DESCRIPTIONS:
                serviceMethod = this.zoningCodeService.getZoneDescriptionsImportTemplate(this.zoningCodeService.zoningCodeId);
                defaultFileName = `${zoningCodeName}-zone-descriptions-import-template.csv`;
                break;
            case ImportTemplateType.CALIBRATION_SET_TABLE_FIELD_ATTRIBUTES:
                serviceMethod = this.zoningCodeService.getCalibrationSetTableFieldAttributesImportTemplate(
                    this.zoningCodeService.zoningCodeId
                );
                defaultFileName = `${zoningCodeName}-calibration-set-table-field-attributes-import-template.csv`;
                break;
            case ImportTemplateType.ZONE_COMBINATION_USES_VALUES:
                serviceMethod = this.zoningCodeService.getZoneCombinationUsesValuesImportTemplate(
                    this.zoningCodeService.zoningCodeId
                );
                defaultFileName = `${zoningCodeName}-zones-uses-import-template.csv`;
                break;
            case ImportTemplateType.ZONE_COMBINATION_CALIBRATION_GENERAL_VALUES:
                serviceMethod = this.zoningCodeService.getZoneCombinationCalibrationGeneralValuesImportTemplate(
                    this.zoningCodeService.zoningCodeId
                );
                defaultFileName = `${zoningCodeName}-zones-general-import-template.csv`;
                break;
            case ImportTemplateType.ZONE_COMBINATION_CALIBRATION_USE_CAPACITY_VALUES:
                serviceMethod = this.zoningCodeService.getZoneCombinationCalibrationOfficeCommercialValuesImportTemplate(
                    this.zoningCodeService.zoningCodeId
                );
                defaultFileName = `${zoningCodeName}-zones-use-capacity-import-template.csv`;
                break;
        }

        serviceMethod.subscribe(
            (resp: HttpResponse<Blob>) => {
                DownloadService.saveBlobToFile(resp.body, DownloadService.getFileName(resp, defaultFileName));
            },
            err => {
                console.error('Failed to download import template', err);
            }
        );
    }
}
